import { useEffect } from "react";
import { userManager } from "../auth/oidc";

export function safeReturnUrl(state) {
  const returnUrl = state?.returnUrl;
  return typeof returnUrl === "string"
    && returnUrl.startsWith("/")
    && !returnUrl.startsWith("//")
    ? returnUrl
    : "/";
}

export default function AuthCallback() {
  useEffect(() => {
    (async () => {
      try {
        const user = await userManager.signinRedirectCallback();
        window.location.replace(safeReturnUrl(user?.state));
      } catch (e) {
        console.error("signinRedirectCallback error", e);
      }
    })();
  }, []);

  return <div style={{ padding: 16 }}>Signing you in…</div>;
}
